import React, { useCallback, useState } from 'react'
import styles from '../../../CSS/main.css'
import classNames from 'classnames'
import Input from '../Input'
import { ButtonIcon } from '../Button/Button'
import RightPanel from '../RightPanel'

type Props = {
  readonly filters: (onClose: () => void) => JSX.Element
  readonly searchTerm: string
  readonly onChangeSearch: (newTerm: string) => void
}

const SearchBox: React.VFC<Props> = ({
  filters,
  searchTerm,
  onChangeSearch,
}) => {
  const [showFilters, setShowFilters] = useState(false)

  const toggleFilters = useCallback(() => {
    setShowFilters(!showFilters)
  }, [showFilters])

  return (
    <div className={styles.SearchNav}>
      <div className={styles.SearchBox}>
        {/*<div className={classNames([styles.Search, styles.IconSearch])}>*/}
        {/*  <Input*/}
        {/*    name={'Search'}*/}
        {/*    placeholder={'Search'}*/}
        {/*    value={searchTerm}*/}
        {/*    onChange={onChangeSearch}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>

      <div className={styles.SearchFilter}>
        <span className={classNames([styles.Notification, styles.NoShow])} />
        <ButtonIcon
          additionalClassNames={[styles.IconFilter]}
          title='Advanced Search'
          onClick={toggleFilters}
        />
      </div>
      <RightPanel
        open={showFilters}
        onClose={toggleFilters}
        title={'Advanced Search'}>
        {filters(toggleFilters)}
      </RightPanel>
    </div>
  )
}

export default SearchBox
